import { call, put, all } from 'redux-saga/effects';
import { SOCKET } from '../../services/api';

import { inIframe } from '../../utils';
import { checkBrowserCookiesAllowed } from '../../utils/handleCookies';
import { AuthTypes as Types } from '../ducks/auth';
import { UserProfileTypes } from '../ducks/userProfile';
import { AppointmentsTypes } from '../ducks/appointments';
import { sagaErrorHandle } from './sagasError';
import { AddLog } from '../../services/log';

import {
  fetchRefreshToken,
  fetchLogin,
  setAuthToken,
  handleSession,
  fetchLoginByGuid,
} from '../../services/auth';

export function* login(action) {
  const {
    credentials: { email, password, keepConnected },
  } = action;
  yield put({ type: Types.LOADING_AUTH, loading: { requestingLogin: true } });

  try {
    if (SOCKET.state !== 'Connected') {
      yield SOCKET.start();
    }

    const user = yield call(fetchLogin, { email, password, keepConnected });
    yield call(AddLog, { actionId: 1 });
    const data = {
      user: user.data,
      keepConnected,
    };
    yield all([
      put({ type: Types.SUCCESS_LOGIN, data }),
      put({ type: AppointmentsTypes.REQUEST_INFOS }),
      call(setAuthToken, user.data.access_token),
    ]);
  } catch (error) {
    const { status, message } = yield sagaErrorHandle({
      sagaName: 'login',
      errorData: error,
      additionalInfos: { email, keepConnected, password: '****' },
    });
    let msg = message;
    if (message === 'Access to product has expired') {
      msg = 'O seu acesso expirou.';
    }
    if (status === 404) {
      msg = 'Usuário ou senha incorretos.';
    }
    yield put({ type: Types.FAILURE_LOGIN, errorData: { status, msg } });
  } finally {
    yield put({
      type: Types.LOADING_AUTH,
      loading: { requestingLogin: false },
    });
  }
}

export function* checkAuth(action) {
  const { accessToken, keepConnected } = action.credentials;
  yield put({ type: Types.LOADING_AUTH, loading: { checkingAuth: true } });
  yield put({ type: Types.REFRESH_TOKEN });
  try {
    yield call(setAuthToken, accessToken);
    if (SOCKET.state !== 'Connected') {
      yield SOCKET.start();
    }
    const response = yield call(fetchRefreshToken, { keepConnected });
    const newAccessToken = response?.data?.access_token;
    if (!newAccessToken) {
      yield put({ type: Types.FAILURE_LOGIN });
    } else {
      yield all([
        put({ type: Types.SUCCESS_AUTH, data: newAccessToken }),
        put({ type: AppointmentsTypes.REQUEST_INFOS }),
        call(setAuthToken, newAccessToken),
      ]);
    }
  } catch (error) {
    yield sagaErrorHandle({
      sagaName: 'checkAuth',
      errorData: error,
      checkValidAuthentication: false,
      additionalInfos: action,
    });
    yield put({ type: Types.FAILURE_LOGIN });
  } finally {
    yield put({ type: Types.LOADING_AUTH, loading: { checkingAuth: false } });
  }
}

export function* logout() {
  yield put({ type: Types.HANDLE_LOGOUT });
  yield put({ type: UserProfileTypes.RESET_USER_PROFILE });
  const logoutRet = yield call(handleSession, 'REMOVE');
  const cookiesAllowed = checkBrowserCookiesAllowed();

  if (logoutRet === 'REMOVE SUCCESS') {
    yield call(AddLog, { actionId: 2 });
    try {
      if (cookiesAllowed) {
        localStorage.clear();
      }
    } catch (error) {
      yield sagaErrorHandle({
        sagaName: 'logout',
        errorData: error,
        checkValidAuthentication: false,
      });
    } finally {
      const appInIframe = inIframe();
      if (appInIframe) {
        const callback =
          'function callback(documentScope) { documentScope.location.reload(true); }';
        const origin = cookiesAllowed
          ? sessionStorage.getItem('appStudentsUrl')
          : window?.appStudentsUrl;
        if (origin) {
          window.parent.postMessage({ action: callback, data: null }, origin);
        } else {
          window.location.reload(true);
        }
      }
    }
  }
}

export function* loginByGuid({ guid }) {
  yield put({ type: Types.LOADING_AUTH, loading: { requestingLogin: true } });

  try {
    const loggingIn = yield call(fetchLoginByGuid, guid);
    const data = yield {
      user: loggingIn.data,
      keepConnected: false,
    };
    yield all([
      put({ type: Types.SUCCESS_LOGIN, data }),
      call(setAuthToken, loggingIn.data.access_token),
    ]);
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'loginByGuid',
      errorData: error,
      checkValidAuthentication: false,
      additionalInfos: guid,
    });
    yield put({ type: Types.FAILURE_LOGIN, errorData: { status, msg } });
  } finally {
    yield put({
      type: Types.LOADING_AUTH,
      loading: { requestingLogin: false },
    });
  }
}
